<template>
  <v-container fluid class="pa-0 ma-0">
    <div v-if="$store.state.auth.wPlaceSettings.employeeList">
      <v-row dense no-gutters>
        <v-col cols="2">
          <b>{{ $t('label.visiting') }}:</b>
        </v-col>
        <v-col cols="5" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap">
          {{ employeeView.name }} {{ employeeView.surname }}
        </v-col>
        <v-col cols="2">
          <b>{{ $tc('label.employeeIdentifier') }}:</b>
        </v-col>
        <v-col cols="2" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap">
          {{ employeeView.orgID }}
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2">
          <b>{{ $t('label.position') }}:</b>
        </v-col>
        <v-col cols="4">{{ employeeView.position }}</v-col>
        <v-col cols="2">
          <b>{{ $tc('label.department') }}:</b>
        </v-col>
        <v-col cols="4">{{ employeeView.department }}</v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2">
          <b>{{ $t('label.floor') }}:</b>
        </v-col>
        <v-col cols="4">{{ employeeView.floor }}</v-col>
        <v-col cols="2">
          <b>{{ $t('label.door') }}:</b>
        </v-col>
        <v-col cols="4">{{ employeeView.door }}</v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2">
          <b>{{ $t('label.phone') }}:</b>
        </v-col>
        <v-col cols="4">{{ employeeView.phone }}</v-col>
        <v-col cols="2">
          <b>{{ $t('label.mobile') }}:</b>
        </v-col>
        <v-col cols="4">{{ employeeView.mobile }}</v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2">
          <b>{{ $t('label.email') }}:</b>
        </v-col>
        <v-col cols="4" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap">
          {{ employeeView.email }}
        </v-col>
        <v-col cols="2">
          <b>{{ $t('label.noteShort') }}:</b>
        </v-col>
        <v-col cols="4">{{ employeeView.note }}</v-col>
      </v-row>
      <hr />
    </div>
    <div v-if="$store.state.auth.wPlaceSettings.carsList">
      <v-row class="pt-1" dense no-gutters>
        <v-col cols="2">
          <b>{{ $tc('label.car') }}:</b>
        </v-col>
        <v-col cols="4">{{ carView.plate }}</v-col>
        <v-col cols="2">
          <b>{{ $tc('label.country') }}:</b>
        </v-col>
        <v-col cols="4">{{ carView.state }}</v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2">
          <b>{{ $t('label.carType') }}:</b>
        </v-col>
        <v-col cols="4">{{ carView.type }}</v-col>
        <v-col cols="2">
          <b>{{ $t('label.carColor') }}:</b>
        </v-col>
        <v-col cols="4">{{ carView.color }}</v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2">
          <b>{{ $t('label.noteShort') }}:</b>
        </v-col>
        <v-col cols="10">{{ carView.note }}</v-col>
      </v-row>
      <hr />
    </div>
    <div v-if="$store.state.auth.wPlaceSettings.companyList">
      <v-row class="pt-1" dense no-gutters>
        <v-col cols="2">
          <b>{{ $tc('label.company') }}:</b>
        </v-col>
        <v-col cols="4">{{ companyView.name }}</v-col>
        <v-col cols="2">
          <b>{{ $t('label.vatNumber') }}:</b>
        </v-col>
        <v-col cols="4">{{ companyView.vatin }}</v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2">
          <b>{{ $t('label.noteShort') }}:</b>
        </v-col>
        <v-col cols="10">{{ companyView.note }}</v-col>
      </v-row>
      <hr />
    </div>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';

class cEmployee {
  name: string = '';
  surname: string = '';
  orgID: string = '';
  position: string = '';
  department: string = '';
  floor: string = '';
  door: string = '';
  phone: string = '';
  mobile: string = '';
  email: string = '';
  note: string = '';
}

class cCar {
  plate: string = '';
  state: string = '';
  type: string = '';
  color: string = '';
  note: string = '';
}

class cCompany {
  name: string = '';
  vatin: string = '';
  note: string = '';
}

export default Vue.extend({
  name: 'worklplaceWidgetInfo',
  props: {
    employee: Object,
    car: Object,
    company: Object,
  },
  data: () => ({
    employeeView: new cEmployee(),
    carView: new cCar(),
    companyView: new cCompany(),
  }),
  watch: {
    employee() {
      // Pri reloade je Prop employee undefined, takze data treba nacitat az ked existuje
      if (this.employee !== undefined) {
        // console.log('te: ', this.employee);
        this.employeeView = this.employee;
      } else {
        this.employeeView = new cEmployee();
      }
    },
    car() {
      // Pri reloade je Prop company undefined, takze data treba nacitat az ked existuje
      if (this.car !== undefined) {
        // console.log('te: ', this.employee);
        this.carView = this.car;
      } else {
        this.carView = new cCar();
      }
    },
    company() {
      // Pri reloade je Prop company undefined, takze data treba nacitat az ked existuje
      if (this.company !== undefined) {
        this.companyView = this.company;
      } else {
        this.companyView = new cCompany();
      }
    },
  },
});
</script>
